import React, { useCallback, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import { FiCopy } from 'react-icons/fi';

import AddUsers from './AddUsers';
import UsersWithAccess from './UsersWithAccess';
import { loadBoardPermissions } from '../../../services/api/api';
import { copyToClipboard } from '../../../services/clipboard';
import { useCurrentBoard } from '../../../services/state';

import '../../../style/Common.css';
import '../../../style/Header.css';
import '../../../style/Modal.css';
import 'react-responsive-modal/styles.css';

const ShareModal = ({ isOpen, onClose }) => {
  const { id: boardId } = useCurrentBoard();
  const isPublic = false;

  const currentUrl = window.location.href;
  const [{ permissions, loading }, setState] = useState({ permissions: {}, loading: true });
  const setPermissions = useCallback(permissions => setState({ permissions, loading: false }), []);
  const clearPermissions = useCallback(() => setState({ permissions: {}, loading: true }), []);

  useEffect(() => {
    if (!boardId || !isOpen) {
      return;
    }

    clearPermissions();
    loadBoardPermissions(boardId).then(permissions => {
      setPermissions(permissions);
    });
  }, [boardId, isOpen, setPermissions, clearPermissions]);

  const copyCurrentUrl = useCallback(() => copyToClipboard(currentUrl), [currentUrl]);

  const addEmailSectionWrapperClasses = `add-email-section-wrapper ${
    isPublic ? 'add-email-section-wrapper-hidden' : 'add-email-section-wrapper-visible'
  }`;

  return (
    <div className="ShareModal">
      <Modal
        open={isOpen}
        onClose={onClose}
        closeIconSize={26}
        classNames={{ modal: 'modal-bg shareDialog', closeIcon: 'close-icon' }}
        center
      >
        <div className={addEmailSectionWrapperClasses}>
          <div className="m-b-3">
            <AddUsers setPermissions={setPermissions} publicLink={isPublic} />
          </div>

          <div className="m-b-3">
            <UsersWithAccess
              permissions={permissions}
              setPermissions={setPermissions}
              loading={loading}
            />
          </div>

          <div className="">
            <h3 className="m-b-1">Get link</h3>
            <div className="copy-link-wrapper m-b-1">
              <div className="copy-link">{currentUrl}</div>
              <div className="copy-icon" onClick={copyCurrentUrl}>
                <FiCopy size={'1rem'} />
              </div>
            </div>

            {isPublic ? (
              <div className="m-t-1 m-b-1">
                <div>Anyone on the internet with this link can view</div>
                <div>
                  <button className="link-btn">Change to restricted - only people added</button>
                </div>
              </div>
            ) : (
              <div className="m-t-1 m-b-1">
                <div>
                  <span className="strong">Restricted</span> Only people added can open with this
                  link
                </div>
                {/*<div><button className="link-btn" onClick={() => setPublic()}>Change to anyone can open with this link</button></div>*/}
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ShareModal;
